// @flow
/* eslint-disable */
import React from 'react';
import classnames from 'classnames';
import { H4, P } from '../Typography';
import clubs from '../../assets/icons/clubs.svg';
import clubsColored from '../../assets/icons/clubsColored.svg';
import spades from '../../assets/icons/spades.svg';
import spadesColored from '../../assets/icons/spadesColored.svg';
import hearts from '../../assets/icons/hearts.svg';
import heartsColored from '../../assets/icons/heartsColored.svg';
import diamonds from '../../assets/icons/diamonds.svg';
import diamondsColored from '../../assets/icons/diamondsColored.svg';
import styles from './styles.module.scss';

type Props = {
  suit?: string,
  value: string,
  size?: string,
  cardMaskShow?: boolean,
  noSuit?: boolean,
  handleClick?: () => void,
  heroCard?: boolean,
  heroColor?: string,
  customColor?: string,
  specialSuit?: boolean,
  preventSelection?: boolean,
  lightCard?: boolean,
}

const PlayingCard = (
  {
    noSuit = false,
    suit = '',
    value,
    size = 'md',
    cardMaskShow = false,
    handleClick,
    heroCard = false,
    heroColor = 'default',
    customColor = null,
    specialSuit = false,
    preventSelection = false,
    lightCard = false,
  }: Props,
) => {
  const heroIsDefault = () => (
    heroColor === 'default' || heroColor === ''
  )
  const hasSuitIcon = ['s', 'h', 'c', 'd'].includes(suit);
  const selectSuit = (s) => {
    if (s === 's') {
      return ['linear-gradient(164.96deg, #676765 0%, #38393B 89.41%), linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15))', spades];
    }
    if (s === 'h') {
      return ['linear-gradient(151.11deg, #BE4F55 0%, #8F393A 100%), linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15))', hearts];
    }
    if (s === 'c') {
      return ['linear-gradient(180.36deg, #70A74A 0.31%, #4B7B27 99.69%), linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15))', clubs];
    }
    if (s === 'd') {
      return ['linear-gradient(151.11deg, #4991B7 0%, #14425C 100%), linear-gradient(0deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15))', diamonds];
    }
    if (s === 'x') {
      return ['linear-gradient(180deg, #FFFFFF 0%, #E7ECF2 100%)', {}];
    }
    if (customColor) {
      return [customColor, {}]
    }
    return ['gray', {}];
  };

  const selectColor = (s) => {
    if (s === 's') {
      return ['#4d4d4e', spadesColored];
    }
    if (s === 'h') {
      return ['#a64347', heartsColored];
    }
    if (s === 'c') {
      return ['#5b8f36', clubsColored];
    }
    if (s === 'd') {
      return ['#2e6889', diamondsColored];
    }
    if (s === 'x') {
      return ['#1B232F', {}];
    }
    return ['grey', {}];
  }

  return (
    <>
      <div
        className={classnames(
          styles.playingCard,
          styles[size],
          `${heroCard ? styles.heroCard : ''}`,
          `${preventSelection ? styles.preventSelection : ''}`,
          { [styles.closedCard]: customColor && !suit }
        )}
        style={{ background: `${lightCard ? 'linear-gradient(180deg, #FFFFFF 0%, #E7ECF2 100%)' : (heroIsDefault() ? selectSuit(suit)[0] : 'white')}` }}
        key={selectSuit(suit)[0]}
        onClick={handleClick}
      >
        <div
          className={classnames(styles.cardMask, { [styles.cardMaskShow]: cardMaskShow })}
        />
        {(!noSuit && hasSuitIcon && !specialSuit) ? <img src={heroIsDefault() ? selectSuit(suit)[1] : selectColor(suit)[1]} className={styles.simg} /> : null}
        {(!noSuit && hasSuitIcon && !specialSuit) ? <img src={heroIsDefault() ? selectSuit(suit)[1] : selectColor(suit)[1]} className={styles.bimg} /> : null}
        {size === 'md' ? <H4 style={{ color: `${lightCard || suit === 'x' ? '#1B232F' : (heroIsDefault() ? 'white' : selectColor(suit)[0])}` }} >{value}</H4> : <P style={{ color: lightCard || suit === 'x' ? '#1B232F' : undefined }} className={styles.playingCardValue} size="big">{value}</P>}
      </div>
    </>
  );
};

export default PlayingCard;
